// Shim. The lookup editor moved to the shared package
// (@twasta/page-runtime/designerKit), where it reads tables, columns and
// transactions from an injected DesignerCatalog. This wrapper supplies the
// builder's catalog (./designerCatalog: the Database Designer's tables merged
// with the deployed preview schema, as before), so every importer keeps its
// props, its `LookupPatch` type and its behaviour.
import type { ComponentProps } from 'react'
import { LookupEditor as KitLookupEditor } from '@twasta/page-runtime/designerKit'
import { usePlatformDesignerCatalog } from './designerCatalog'

export type { LookupPatch } from '@twasta/page-runtime/designerKit'

type Props = Omit<ComponentProps<typeof KitLookupEditor>, 'catalog'>

export default function LookupEditor(props: Props) {
  const { catalog, confirmDialog } = usePlatformDesignerCatalog(props.project)
  return (
    <>
      <KitLookupEditor {...props} catalog={catalog} />
      {confirmDialog}
    </>
  )
}
